import React from 'react';
import tw from 'twin.macro';

const InputText = tw.input`w-full truncate dark:text-darkText dark:placeholder:text-gray-500 dark:bg-darkSecondary p-2 border border-gray-200 rounded-md mb-1.5 dark:border-gray-600 focus:outline-none focus:border-gray-300  dark:focus:border-gray-300 dark:caret-darkText`;

export default InputText;
